import sanitizeRichTextHtml from './sanitizeRichTextHtml';

function modifyParsedHTMLcontent(htmlContent: string) {
  // Step 2: Sanitize the HTML
  const cleanHtml = sanitizeRichTextHtml(htmlContent);

  // Step 3: Convert string to DOM
  const parser = new DOMParser();
  const doc = parser.parseFromString(cleanHtml, 'text/html');

  // Step 4: Modify the <div> tags
  const divs = doc.querySelectorAll('div');
  divs.forEach((div) => {
    div.style.removeProperty('font-family');
    div.style.removeProperty('font-size');
    div.style.removeProperty('color');
  });

  // Step 5: Modify <font> tags
  const fonts = doc.querySelectorAll('font');
  fonts.forEach((font) => {
    font.removeAttribute('face');
    font.classList.add('text-secondary-base');
    font.classList.add('text-sm');
    font.style.removeProperty('font-size');
  });

  // Step 6: Modify the <a> tags
  const links = doc.querySelectorAll('a');
  links.forEach((link) => {
    link.setAttribute('target', '_blank');
  });

  // Step 7: Serialize the document back to HTML
  return doc.body.innerHTML;
}

export default modifyParsedHTMLcontent;
